import { Link, usePathname } from 'expo-router';
import { StyleSheet, View, type ViewProps } from 'react-native';

import { handleMenuTileImageLoadEvent, useMenuClickEvents } from '@fhs/menu/src/analytics';

import { ProductListTile } from '../product-list-tile';

import type { ItemType, TileSizeType } from './types';

export type SectionListItemProps = {
  tileSize: TileSizeType;
  style?: ViewProps['style'];
  item: ItemType;
};

export const SectionListItem = ({ tileSize, item, style }: SectionListItemProps) => {
  const pathname = usePathname();
  const { logMenuItemClick } = useMenuClickEvents();

  return (
    <View style={[containerStyles.container, style]}>
      <Link href={item.href} asChild>
        <ProductListTile
          onPress={() => {
            logMenuItemClick(item.title);
          }}
          size={tileSize}
          image={item.image}
          title={item.title}
          description={item.description}
          badge={item.badge}
          isAvailable={item.isAvailable}
          onLayout={() => {
            // Send event in similar way as we are doing for legacy menu (TileImage from src/components/menu-tile-grid)
            handleMenuTileImageLoadEvent(item.id, pathname);
          }}
        />
      </Link>
    </View>
  );
};

const containerStyles = StyleSheet.create({
  container: {
    overflow: 'hidden',
    flexGrow: 1,
    flexShrink: 1,
  },
});
